import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { updateSkipped, updateCompleted } from 'redux/slices/activeWorkoutV5'
import { PencilSquareIcon, ArrowPathIcon, ArrowUturnLeftIcon, ForwardIcon, CheckCircleIcon } from '@heroicons/react/24/outline'
import { IsActiveWorkoutSwappedSlot } from 'functions/workoutUtils'

import LabelledIconButton from 'components/Buttons/LabelledIconButton'

export default function ActionButtonsV5({
    kinesisWorkoutAssignmentType,
    groupIndividual,
    phaseIndex,
    slotIndex,
    exercise,
    setIndex,
    set,
    isCompleted,
    isSkipped,
    showLabel = true,
    slot = null,
    CalculateWeightRecommendations = () => {},
    OnSwapButton = null, // Only set for the base set item (a swap applies to the whole group)
    OnUndoSwapButton = null
}) {

    const { urlWorkoutId } = useParams()

    const dispatch = useDispatch()

    const OnEditButton = () => {

        const payload = {
            kinesisWorkoutAssignmentType: kinesisWorkoutAssignmentType,
            workoutId: urlWorkoutId,
            groupIndividualId: groupIndividual?.id,
            phaseIndex: phaseIndex,
            slotIndex: slotIndex,
            setIndex: setIndex,
            value: 0
        }

        dispatch(updateCompleted(payload))
        dispatch(updateSkipped(payload))

        // For group recalculate all weight recommendations

        if (
            kinesisWorkoutAssignmentType === 'group'
            && exercise.exerciseType === 'recommendation'
        ) {
            CalculateWeightRecommendations([phaseIndex], [slotIndex], true)
        }

    }

    const OnSkipButton = () => {
        const payload = {
            kinesisWorkoutAssignmentType: kinesisWorkoutAssignmentType,
            workoutId: urlWorkoutId,
            groupIndividualId: groupIndividual?.id,
            phaseIndex: phaseIndex,
            slotIndex: slotIndex,
            setIndex: setIndex,
            value: 1
        }

        dispatch(updateSkipped(payload))
    }

    const OnSaveButton = () => {
        if (
            exercise.exerciseType === 'recommendation' &&
            set?.weightRecommendationLoaded === false
        ) {
            return
        }

        // Update redux store

        const setCompletionPayload = {
            kinesisWorkoutAssignmentType: kinesisWorkoutAssignmentType,
            workoutId: urlWorkoutId,
            groupIndividualId: groupIndividual?.id,
            phaseIndex: phaseIndex,
            slotIndex: slotIndex,
            setIndex: setIndex,
            value: 1
        }

        dispatch(updateCompleted(setCompletionPayload))

        if (exercise.exerciseType === 'recommendation') {
            CalculateWeightRecommendations([phaseIndex], [slotIndex], true)
        }
    }

    // Edit Button

    if (isSkipped === 1 || isCompleted === 1) {
        return (
            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Edit</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<PencilSquareIcon className='w-10 h-10 text-gray-500' />}
                        action={OnEditButton}
                    />
                </div>
            </div>
        )
    }

    // Skip, Swap, and Save Buttons

    return (
        <>
            {OnSwapButton !== null && slot !== null && IsActiveWorkoutSwappedSlot(slot) === false && (
                <div className='space-y-2'>
                    {showLabel && (
                        <div className='text-xs text-center text-gray-600'>Swap</div>
                    )}

                    <div className='w-20 h-20'>
                        <LabelledIconButton
                            icon={<ArrowPathIcon className='w-10 h-10 text-gray-500' />}
                            action={() => OnSwapButton(phaseIndex, slotIndex)}
                        />
                    </div>
                </div>
            )}

            {OnUndoSwapButton !== null && slot !== null && IsActiveWorkoutSwappedSlot(slot) === true && (
                <div className='space-y-2'>
                    {showLabel && (
                        <div className='text-xs text-center text-gray-600'>Undo</div>
                    )}

                    <div className='w-20 h-20'>
                        <LabelledIconButton
                            icon={<ArrowUturnLeftIcon className='w-10 h-10 text-gray-500' />}
                            action={() => OnUndoSwapButton(phaseIndex, slotIndex)}
                        />
                    </div>
                </div>
            )}

            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Skip</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<ForwardIcon className='w-10 h-10 text-gray-500' />}
                        action={OnSkipButton}
                    />
                </div>
            </div>

            <div className='space-y-2'>
                {showLabel && (
                    <div className='text-xs text-center text-gray-600'>Save</div>
                )}

                <div className='w-20 h-20'>
                    <LabelledIconButton
                        icon={<CheckCircleIcon className='w-10 h-10 text-white' />}
                        style="brand-color"
                        disabled={exercise.exerciseType === 'recommendation' && !set?.weightRecommendationLoaded}
                        action={OnSaveButton}
                    />
                </div>
            </div>
        </>
    )
}
